import { howItWorksSteps } from '@/mocks/siteData';

export default function HowItWorks() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            How Vigorbuy Spreadsheet Works
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            Three simple steps to transform the way you research and discover products.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6 max-w-[1000px] mx-auto">
          {howItWorksSteps.map((step) => (
            <div key={step.step} className="relative text-center">
              <div className="w-14 h-14 rounded-2xl bg-accent-100 flex items-center justify-center mx-auto mb-5">
                <span className="font-heading text-xl font-bold text-accent-600">{step.step}</span>
              </div>
              <h3 className="font-heading font-semibold text-base text-foreground-900 mb-3">
                {step.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {step.description}
              </p>
              {step.step < 3 && (
                <div className="hidden md:block absolute top-7 left-[calc(50%+40px)] w-[calc(100%-80px)] h-px bg-background-300">
                  <div className="absolute right-0 top-1/2 -translate-y-1/2 w-2 h-2 rounded-full bg-accent-300"></div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}